module.exports = __webpack_public_path__ + "static/media/ar_chat.2c8ea035.JPG";